var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1024v1024h-1024z",
    fill: "#98C1FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(514,168)",
    d: "m0 0h10l5 2 7 6 5 7 9 7 3 4 3 9 2 13 3 11 5 9 7 12 1 5 1 16 4 11 7 8 22 10 7 6 6 11 2 6v18l-3 2v-2h-2l-7-8-3-3v-2l-4-2-12-13-8-8-8-10v-2l-4-2-8-6-23-6-7-3-4-5-1-4v-17l5-4 6-15 5-3 4-8v-6l-1-2h-6l-2 6h-2l-1-7h-12l-8 1v-3l10-3-7-5-5-6-5-5-2-4-2-1-1 6-6 9-7 9 2-1 13 1v4l-3 1-5-2h-13v9l-2-1-2-7-5 2v9l4 7 6 1 3 12 2 4 4 2 6 5-1 14-2 6-15 6-6 1 2 28 12 4 12 5 4 2h10l7-2 12-5 7-3 7-1 3-26 2 1v7l-1 3-1 16 5 9v10l-1 3h2v-8l2-1 3 1 14 14 11 9 7 6 9 7 8 7-1 5-4 8-1 3v13l3 10-1 9-5 12 9 1 13 2h21l27-4 19-5 16-5h9l10 5 4 3 3 1v2l3-1-1-5-7-7v-3l4-1h7l8 5 4 1 1-2 5 1 9 3 4 4v2l4 1 3 5 2 1v2h2l8 14 5 14 4 22v46l-5 28-4 14-4 15-4 8-4 11v3h-2l-3 9-7 16-8 14-4 6-1 4-2 1-3 5-2 2-2 8 5 2 2 5-1 6-6 16-6 15-4 7-12 23-7 9-9 13-13 13-11 9-9 6-4 4-32 16-7 2-10 4-22 6-17 3-25 4-12 1 4 20 2 8v9l-3 6-8 3h-7l-6-3-4-7v-12l3-14v-7l-2-1h-18l2 21 1 2v12l-4 6-5 3h-9l-6-3-4-7v-8l3-9 3-15v-13l-24-2-10-1-4 2v5l-2 1h-9l-24-7-13-4-20-8-16-8-17-11-14-10-7-6v-2l-4-2-5-3-16-8-16-12-16-16-12-16-7-11-9-17-7-15-8-24-5-19v-8l15-5 11-4h2l-7-27-3-23v-33l2-17 5-23 6-20 11-25 11-20 5-8-3-1 1-6 12-14 5-3 4-1 14-1 19-10 10-5 17-10 9-6 19-9 9-4 8-6 6-6h2l2-4 5-4 7-8 3-3h2l2-4 7-7 7-8 2-2 1-9 6-12 5-7v-10l-6-11v-13l4-8 6-7 2-5 3-18 9-17 6-7 10-5h8l4 1z",
    fill: "#D0443E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,84)",
    d: "m0 0h18l26 2 19 3 24 6 20 6 13 5 7 2 5 3 10 4 15 7 10 5 14 8 10 6 11 7 5 4 9 6 8 6 10 7v2l4 2 10 9 6 4 4 5 6 5v2l5 2 3 3v3l4 2 11 12 11 13 4 5v2h2l4 6 4 5 3 5 7 10 5 8 3 5 11 20 9 19 5 13 2 3 3 11 4 12 6 27 3 22 1 17v15l-2 22-4 21-6 17-6 15-3 3-5 9-8 11-2 3h-2l-1 3h-2l-2 4-5 5-10 9-6 4-14 9h-1l1-7 4-18 4-22v-46l-4-22-6-16-6-10v-2h-2v-2l-4-2-2-4-3-1-5-6-8-2-5-2-1 3-7-3-5-3h-11l3 5 6 6-1 5h-3v-2l-5-1-5-4-7-3h-9l-16 5-19 5-27 4h-21l-13-2-9-2 1-4 4-12-1-9-2-6v-13l4-9 2-4-1-4-4-3v-2l-5-2-6-5-8-7-14-12-10-9v-2h-4l-1 8-3 1 1-4v-10l-5-9 1-16 1-3v-7l-2 13-1 12-1 1-9 2-16 6-3 2-5 1h-10l-25-10-4-2-2-28 9-3 10-4h3l2-13v-7l-9-7-4-6-1-10h-6l-5-8v-9l2-2h4l3 7 1-8 2-1h11l6 2h2v-4h-15l2-4 9-12 3-8 3 1 4 7 3 2v2l4 2 2 3 5 3 1 2-11 2v3l8-2h12l1 1v7l2-1 2-5 6-1 2 3-1 9-6 8h-3l-3 11-3 5-4 3v17l3 7 2 2 13 4 16 4 12 9 6 8 11 12 8 8 5 6 12 12v2h4v-18l-4-10-5-8-9-6-18-8-7-7-4-9-1-4-1-16-3-9-6-9-5-11-3-11-2-14-4-8-11-9-3-4v-2l-3-1-5-5-4-1h-10l-8 2-2-1h-8l-10 5-6 8-8 15-4 21-6 8-4 6-1 3v13l6 11v10l-9 14-2 5-1 9-8 8-7 8-4 5-8 7-4 5-6 5-12 12-8 5-13 5-15 8-18 11-12 7-22 11-14 1-8 3-10 11-3 5v4l2 1-2 5-12 21-11 24-6 19-5 21-2 12-1 11v33l3 23 6 24v3l-24 9h-4l3 17 8 26 8 19 8 16 10 16 10 13 9 10 9 9 16 12 18 8 6 5v2l4 2 1 3 5 2 18 13 14 8 6 3v1h-29l-16-2-24-8-19-9-8-5v-2l-5-1-4-4-11-7-14-14-5-4-7-8-10-11-2-5h-2v-2h-2l-4-7-4-4-7-10-7-11-10-16-6-10-6-11-4-8v-3h-2l-4-10-6-14-5-11-7-18-3-11-4-10-6-24-3-14-3-16-2-11-2-21v-35l3-21 4-14 3-8 8-18 9-12 9-11 3-1 2-4 10-8h2v-2l7-4 14-9 19-9 8-4 16-6 16-8 5-2h3v-2l9-6 9-5 9-7 11-10h2l2-4 8-8 6-8 7-11 2-2 5 1 7 6 5 11 4 18 3 20 2-21 3-15 6-13 11-8 17-5 22-3-16-2-15-3-12-5-7-7-5-10-3-16v-10l6-16 10-19 9-13 9-11h2v-2l8-7 11-9 13-8 9-5 7-1v-2l16-5 12-2 2-1z",
    fill: "#FCFCFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(457,331)",
    d: "m0 0 4 1-3 14-2 6v16l6 10 6 5 6 4v2l5-1 1-2h3v2h5v7l-3 1-2 7-2 5-2 8-5 9-7 14-5 13-6 12-3 5-3 7-8 16h-2v4h-2l-1 6-8 15-6 10-5 9h-2l-1 5-5 9-4 6-4 8-7 10-1 2h-2l-1 5-4 5-5 9-4 5h-2l-1 4-5 7h-2v3h-2l-2 5-3 2-1 3h-2l-4 8h-2l-2 5-2 3h-2l-2 5-9 9-1 2h-2l-2 6-4 2-1 4h-2l-1 4h-2v5h-2v3h-2l-1 14 1 4 6 4v2l12-1 5-3 8-3 1-3-1-2 1-2h2l2-6 1-1 7 1h3l3-3h2v-3l5-5 3-1 2-4 4-4h2l1-4 3-8 5-6 5-12h2v-2h2l2-6 8-16 2-6h2l3-9 6-13 4-11 2-3 3-12 4-10 5-10h2l1-8h2l3-13 4-9 2-8 4-10 1-5h2l1-7 4-16 4-11 4-13 3-10 4-14 1-5 5-13v-4h13l1 2-3 35-1 7-1 19-4 54-4 41-2 22-2 13-2 30-1 5-2 21-2 20-1 1-2 18-5 32-4 28-2 8-3 19-4 19-1 7-1 1-3 16-3 12-1 2h4v2l-4 2v5l-2 1h-9l-24-7-13-4-20-8-16-8-17-11-14-10-7-6v-2l-4-2-5-3-16-8-16-12-16-16-12-16-7-11-9-17-7-15-8-24-5-19v-8l15-5 11-4h2l-5-19 1-4 4 14 1 8 6-2v-2l9-3 5-3 17-8 11-7 12-6h2l1-3 7-5 9-5 4-2 1-3 10-8 4-4 5-2 5-4h3l2-5 13-12 4-4h2l2-4 13-15 1-2h2l2-4 9-11 10-13 3-3 4-7 3-2 3-7h2l1-4 13-21 1-3h2l1-4 3-5 2-2h-3l-9 11-5 3-10 7-10 5-8 2-15 1-13-2-20-6-16-8-24-13-14-8 2-5 5-3 17-5 23-8 19-7 20-8 9-7 11-8 14-11 4-4h2v-2l8-6h2v-2h2v-2z",
    fill: "#FD5B50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,391)",
    d: "m0 0h11l1 1 2 47 1 29 2 12 1 22 2 7v11l3 36 2 12 2 18 2 9 2 19 2 5 2 13 4 17 2 5 2 10 3 8 1 8h2l4 8 1 8h2l3 8 3 4v5l3 1 3 6 2 1v3l4 2 4 4v2l4 2v2l6 2 3 3 3 1v2l8 2h11l4-1 1 1h5l5-2 1-8 1-5 1-3h-2l-2-11-1-6-3-1-5-10v-4h-3l-5-8-2-5-1-3h-2l-4-8-5-8-2-5v-3l-3-1-5-9v-6h-2l-12-24-5-14v-2h-2l-3-8-2-3-2-8-2-5-2-10h-2l-3-11-2-9-3-7-3-11-1-1-6-31-4-14-6-28-2-11-2-7-1-20h-2v-6l-1-2-1-16 1-1h7l3 9 2 5v5l4 2 8 20 9 22 5 11 4 7 3 7 9 16 3 5 5 8 2 5 7 10 8 11v2l5 5 2 5h2l6 8v3l6 2 2 1v8l4 2 1 3 5 5 6 5v3l4 2 2 4h2l3 3v2l4 2 5 6 5 5 7 6v2h3l3 3 2 1v3l4 2 4 3v2l5 1 3 2v2h2l3 3 6 4v2l5 2v2l4 1 4 3v2h4v2l5 2 12 9h2l4-4-1 7 5 2 2 5-1 6-6 16-6 15-4 7-12 23-7 9-9 13-13 13-11 9-9 6-4 4-32 16-7 2-10 4-22 6-17 3-25 4-12 1 4 20 2 8v9l-3 6-8 3h-7l-6-3-4-7v-12l3-14v-7l-2-1h-18l2 21 1 2v12l-4 6-5 3h-9l-6-3-4-7v-8l3-9 3-15v-14l3-1 2-82 1-39 1-7 2-33v-18l2-65 2-81 3-84 1-19z",
    fill: "#FD5B50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(469,281)",
    d: "m0 0h5l2 4 1 12v12l-3 3-2 9-5 2-5 5-1 3-9 3v2h-2v2l-8 6h-2v2l-11 9-14 11-8 6-9 6-12 5-19 7-29 10-20 6-4 6 5 2 24 13 19 10 12 5 18 5 15 1 13-2 11-4 12-8 3-3 3-1 9-11 4-1-1 4h-2l-2 5-2 4h-2l-1 4-12 20-2 4h-2l-1 4-2 4-5 5-3 5-16 20-7 9h-2l-2 4-12 14-16 16-5 4-2 4-6 3-3 3-5 2-11 10h-2l-1 4-9 5-11 7-3 3-12 6-13 8-15 7-7 4-7 1v2l-3 2h-3l-4-14-1-8h-2l-3-19-1-8v-33l2-17 5-23 6-20 11-25 11-20 5-8-3-1 1-6 12-14 5-3 4-1 14-1 19-10 10-5 17-10 9-6 19-9 9-4 8-6 6-6h2l2-4 5-4 7-8 3-3h2l2-4 7-7 7-8 2-2 1-9h1l1 5 3-4h2l2-4z",
    fill: "#D0443E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(748,694)",
    d: "m0 0 32 6 4 1v2l7 1 1 3 4 2 1 1v5l-4 4-1 4 5 2 3 1v2l4 2 15 2 13 1 9 3 2 3-1 4-9 3-21-1-12-3h-8l-16 4-12 2v2l16 2 9 2 25 2 50 2 20 2 12 3 8 3v2h2v6h-2v2l-11 5-17 9-20 7-14 5-10 3-8 3-16 3-4 2-9 2-12 3-13 3v2l4 3-1 5-5 1v2l-12 5-18 6-10 1v2l-19 3-13 3h-12v2l-36 4-16 2-37 2-34 1-2 1-3 7-4 1-2 5-1-2 2-4v-9l-5-22v-6l2-1 23-3 24-4 21-5 15-5 3-2 7-2 30-15 8-7 9-6 4-2 1-3 8-7 5-6h2l2-5 8-10 7-11 10-19 5-10z",
    fill: "#7DA3DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(511,389)",
    d: "m0 0 9 1h10l3 7 3 13h-2l-3-10-2-7v-2l-7 1 1 16 1 3-1 5h2l2 16 1 5 3 14 1 7 4 17 2 9 6 26 3 17 2 3 4 15 2 7 2 5 1 9h2l2 4 2 8 2 5 2 8 2 2 1 7h2l10 25 4 7 3 6v2h2l2 8 4 7 2 1 5 12 6 9v3h2l3 4 3 7 2 5h3l4 10 2 4 2 1 3 10v7h2v7l-3 9-5 3h-5l-4-1-4 1h-10l-6-3v-2l-4-1-8-5-4-4v-2l-3-1-5-5v-3l-3-1-3-6-2-1-2-6-4-7v-4h-2l-3-11-2-5h-2l-5-16-3-13-4-14-2-8-2-13-2-10-1-11-3-15-2-20-2-16-2-28v-7l-2-10-2-28-1-3-1-29-2-47-11-1-3 87-2 54-1 49-2 65v20l-2 31-1 9-3 111v9h-18l-16-2-8-2 4-17 2-13 1-1 4-23 3-15 2-13 2-10 7-46 2-12 1-12 1-1 3-27 1-14 2-15 1-20 3-22 3-33 3-32 4-56v-8l2-13 2-26h2v-3z",
    fill: "#ED5045"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(514,168)",
    d: "m0 0h10l5 2 7 6 5 7 9 7 3 4 3 9 2 13 3 11 5 9 7 12 1 5 1 16 4 11 7 8 22 10 7 6 6 11 2 6v18l-3 2v-2h-2l-7-8-3-3v-2l-4-2-12-13-8-8-8-10v-2l-4-2-8-6-23-6-7-3-4-5-1-4v-17l5-4 6-15 5-3 4-8v-6l-1-2h-6l-2 6h-2l-1-7h-12l-8 1v-3l10-3-7-5-5-6-5-5-2-4-2-1-1 6-6 9-7 9 2-1 13 1v4l-3 1-5-2h-13v9l-2-1-2-7-5 2v9l4 7 6 1 3 12 2 4 4 2 6 5-1 14-2 6-15 6-6 1 2 28 12 4 12 5 4 2h10l7-2 12-5 7-3 7-1 3-26 2 1v7l-1 3-1 16 5 9v10l-1 3h2v-8l2-1 3 1 14 14 11 9 7 6 9 7 8 7-1 5-4 8-1 3v13l3 10-1 9-5 12 9 1 13 2h21l27-4 19-5 13-4 3 1-5 1-1 2-5 1-1 2-16 5-1 1-17 2-2 1-11 1h-27l-17-3-15-5-1-3-5-1-4-2v-2l-6-1-5-4v-2l-6-2-4-5-7-8-4-7v-35l-17-1-5-2v-2l-5-1-12-2-10 5-9 2-10 1v8l2 3v21l5 1v1l-9-1-1 3h-5l-4-4-6-4-7-9-2-4v-16l4-13 2-11 5-5 4-2 1-2 3-8 2-2v-14l-1-10-1-4-9 3-6 4-6 7h-1v-8l5-10 5-7v-10l-6-11v-13l4-8 6-7 2-5 3-18 9-17 6-7 10-5h8l4 1z",
    fill: "#D0443E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,183)",
    d: "m0 0 3 1 4 7 3 2v2l4 2 2 3 5 3 1 2-11 2v3l8-2h12l1 1v7l2-1 2-5 6-1 2 3-1 9-6 8h-3l-3 11-3 5-4 3v17l3 7 2 2 13 4 16 4 12 9 6 8 11 12 8 8 5 6 12 12v2h4l1 4 1 3 4 2 5 5 15 5 9 5 9 6 10 6 22 13 10 6 10 4h18l11 7 6 5 8 3 4 3-5-1-5-2-1 3-7-3-5-3h-11l3 5 6 6-1 5h-3v-2l-5-1-5-4-7-3h-9l-16 5-19 5-27 4h-21l-13-2-9-2 1-4 4-12-1-9-2-6v-13l4-9 2-4-1-4-4-3v-2l-5-2-6-5-8-7-14-12-10-9v-2h-4l-1 8-3 1 1-4v-10l-5-9 1-16 1-3v-7l-2 13-1 12-1 1-9 2-16 6-3 2-5 1h-10l-25-10-4-2-2-28 9-3 10-4h3l2-13v-7l-9-7-4-6-1-10h-6l-5-8v-9l2-2h4l3 7 1-8 2-1h11l6 2h2v-4h-15l2-4 9-12z",
    fill: "#DFA888"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(510,344)",
    d: "m0 0 10 1 8 3v2l5 1 17 1 1 4v5h-2v16l-1 7-13 3-8 1h-34l3 2h-6l1 4-5 14-1 4-4 14-3 10-5 15-4 13-5 19h-2l-1 7-4 10-2 7-3 8-4 13h-2l-1 8h-2l-3 9-4 9-3 9-2 7-4 8-4 10-7 16h-2l-1 6-11 22h-2v2l-2 1-5 13-5 5-2 7-2 4-7 6-7 8h-2v3l-7 5-3-2h-5l-3 6h-2l1 5-2 3-12 5-1 1h-12l-4-4-3-2-1-10 2-8h2v-3h2v-5h2l1-4 2-1 1-3 4-3 2-5h2l2-5 4-3h2l2-5 5-6 3-5h2l1-4 3-4h2l1-4 4-4 1-2h2v-3l3-3 4-5 1-3 5-5 6-10 4-5 1-4h2l2-5 6-8 3-7 4-6 7-14h2l2-5 6-11 7-12 5-12h2v-4h2l2-7 7-12 2-5 8-16 6-15 4-7 2-5 6-11 2-9 4-9 2-1 1-7h-5l3-2-2-1-1-21-2-3v-8l1-1 10-1 11-3z",
    fill: "#ED5045"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(457,331)",
    d: "m0 0 4 1-3 14-2 6v16l6 10 6 5 6 4v2l3 1-6 11-5 8-6 10-5 5-6 7-5 3-10 7-10 5-8 2-15 1-13-2-20-6-16-8-24-13-14-8 2-5 5-3 17-5 23-8 19-7 20-8 9-7 11-8 14-11 4-4h2v-2l8-6h2v-2h2v-2z",
    fill: "#FCFCFC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(514,168)",
    d: "m0 0h10l5 2 7 6 5 7 9 7 3 4 3 9 2 13 3 11 5 9 7 12 1 5 1 16 4 11 7 8 22 10 7 6 6 11 2 6v18l-3 2v-2h-2l-7-8-3-3v-2l-4-2-12-13-8-8-8-10v-2l-4-2-8-6-23-6-7-3-4-5-1-4v-17l5-4 6-15 5-3 4-8v-6l-1-2h-6l-2 6h-2l-1-7h-12l-8 1v-3l10-3-7-5-5-6-5-5-2-4-2-1-1 6-6 9-7 9 2-1 13 1v4l-3 1-5-2h-13v9l-2-1-2-7-5 2v9l4 7 6 1 3 12 2 4 4 2 6 5-1 14-2 6-15 6-13 2-12 7-6 7h-1v-8l5-10 5-7v-10l-6-11v-13l4-8 6-7 2-5 3-18 9-17 6-7 10-5h8l4 1z",
    fill: "#201B18"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,397)",
    d: "m0 0h1v50l-3 85-1 49-2 65v20l-2 31-1 9-3 111v9h-18l-16-2-8-2 4-17 2-13 1-1 4-23 3-15 2-13 2-10 7-46 2-12 1-12 1-1 3-27 1-14 2-15 1-20 3-22 3-33 3-32 4-56v-8l2-13z",
    fill: "#AE362D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,183)",
    d: "m0 0 3 1 4 7 3 2v2l4 2 2 3 5 3 1 2-11 2v3l8-2h12l1 1v7l2-1 2-5 6-1 2 3-1 9-6 8h-3l-3 11-3 5-4 3v17l3 7 2 2 13 4 12 3-3 1v6h-1l-1-5-2 13-1 12-1 1-9 2-16 6-3 2-5 1h-10l-25-10-4-2-2-28 9-3 10-4h3l2-13v-7l-9-7-4-6-1-10h-6l-5-8v-9l2-2h4l3 7 1-8 2-1h11l6 2h2v-4h-15l2-4 9-12z",
    fill: "#DFA988"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(368,810)",
    d: "m0 0h10l11 5 21 8 27 7 2 1h9l2-6 4-2 20 2 14 1 1 1v13l-3 15-3 9-1-3h-15l-1 3-5 1-14-1-30-4-20-4-5-2-8-2-8-3-16-1-22-3-6-2-14-3-9-5-1-3h-2l-1-4 1-2h2v-2l4-3 8-3 5-2 9-1 10-2z",
    fill: "#7EA3DD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(469,281)",
    d: "m0 0h5l2 4 1 12v12l-3 3-2 9-5 2-5 5-1 3-9 3v2h-2v2l-8 6h-2v2l-11 9-14 11-8 6-9 6-12 5-19 7-29 10-20 6-4 6 5 2-2 1-7-1-10 6-6 4-3-1v-5l6-5 3-5-7 2-4 2-6 10-1 2h-2l1-4-3-1 1-6 12-14 5-3 4-1 14-1 19-10 10-5 17-10 9-6 19-9 9-4 8-6 6-6h2l2-4 5-4 7-8 3-3h2l2-4 7-7 7-8 2-2 1-9h1l1 5 3-4h2l2-4z",
    fill: "#DFA989"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561,322)",
    d: "m0 0 4 1 14 14 11 9 7 6 9 7 8 7-1 5-4 8-1 3v13l3 10-1 9-4 9-1 1-9-1-13-6-11-7-7-6-7-8-4-6-3-4v-21l5-19 3-7z",
    fill: "#1E1B18"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(614,367)",
    d: "m0 0 4 2 7 6 12 6 14 6 15 5 9 4 16 5 23 8 1 5-11 4-13 4-21 5-22 3h-21l-13-2-9-2 1-4 4-12-1-9-2-6v-13l4-9z",
    fill: "#FBFCFC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,183)",
    d: "m0 0 3 1 4 7 3 2v2l4 2 2 3 5 3 1 2-11 2v3l8-2h12l1 1v7l2-1 2-5 6-1 2 3-1 9-6 8h-3l-3 11-3 5-4 3-1 17-9 2-8-3v-2l-5-1-3-3v-2h-2l-3-5-7-5-4-6-1-10h-6l-5-8v-9l2-2h4l3 7 1-8 2-1h11l6 2h2v-4h-15l2-4 9-12z",
    fill: "#DCA284"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,665)",
    d: "m0 0 1 4-1 3 5 2 2 5-1 6-6 16-6 15-4 7-12 23-7 9-9 13-13 13-11 9-9 6-4 4-32 16-7 2-10 4-22 6-17 3-25 4-12 1 4 20 2 8v9l-3 6-8 3h-7l-6-3-4-7v-12l3-14v-7l-2-1h-18l2 21 1 2v12l-4 6-5 3h-9l-6-3-4-7v-8l3-9 3-15v-14h4l1 7 4 2 12-1h32l6-2 22-2 28-5 6-2 11-2 11-4 10-4 16-7 9-4 5-3 4-4 6-3 8-5 11-9 7-8 9-10 7-11 2-3h2l2-6 6-10 4-10 2-1 5-14 2-2 3-9 3-10 3-6-4-1-2-4-3-1 2-4z",
    fill: "#DFA888"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(352,169)",
    d: "m0 0h2l1 23 2 11v5h2l3 9 5 8 6 5 13 5 17 3 11 1 1 2-23 3-17 5-8 6-3 1-1 4-4 9-3 15-2 21-2 1-5-32-5-14-5-8-5-4-18-5-23-2v-1l29-4 13-5 3-1v-2h2v-2l5-5 6-18 2-16z",
    fill: "#6FA5E1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,279)",
    d: "m0 0 4 1 2 28 12 4 12 5 4 2h10l7-2 12-5 7-3 7-1 3-26 2 1v7l-1 3-1 16 5 9v10l-6 8-9 4-8 1h-16l-5-1-4 1h-20l-7-2-4-1v-2l-5-1-2-3-2-13 3-8 2-2v-14l-1-10-1-4-3-1z",
    fill: "#EC5045"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(431,462)",
    d: "m0 0 1 3-2 2-3 8-8 9-8 11-8 9-1 2h-2l-2 4-12 14-16 16-5 4-2 4-6 3-3 3-5 2-11 10h-2v2l-5 1 2-1 1-4 10-17 7-8 4-7 5-6h2l2-4 4-5 2-3 4-2 1-2h2l2-4 5-4h2l1-3 7-2 3-5h3v-3l6-4 8-8 8-7 4-6z",
    fill: "#AD352C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(714,415)",
    d: "m0 0 7 1 8 4 4 3 3 1v2l6-1-2 7-2 14-4 14-3 12-3 9-4 5h-2l-2 6-6 12h-2l-1 4-6 12-7 6-1-2 5-8 2-5h2l3-9 4-9 3-8 6-26 3-11 2-11v-5l-9 9h-2l-2 5-7 6-9 11-7 6h-3v-3l3-3 4-7 5-5 7-9 6-10h2l4-8 1-6-7-1z",
    fill: "#B2423B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(489,827)",
    d: "m0 0 2 4 1 4 4 1h10l3 2h-2l2 21 1 2v12l-4 6-5 3h-9l-6-3-4-7v-8l3-9 3-15z",
    fill: "#DFA888"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(467,322)",
    d: "m0 0h2l2 14 6 20 2 6 1 9v13l-2 4-5-1-9-6-7-9-2-4v-16l4-13 2-11 5-5z",
    fill: "#201B18"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(304,418)",
    d: "m0 0 5 1 8 16 7 9 6 9 2 6 5 5-2 1-6-3-1-3-3-1-1-4h-2l-3-4v-2l-3-1-2-4-7-6v9l4 22 1 1v11h2l4 13v3h2l1 8h2l1 6-4-4-5-8-1-4-2-1-3-8-3-7-2-8-5-12-4-21-1-12 5-3h2z",
    fill: "#AC352C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(246,593)",
    d: "m0 0 2 2 4 17 1 4-2 2h-3v2l-7 3-10 2-4 8 2 9 3 11 1 7 6 15 2 6h2l4 11v2h2l1 7h2l7 11 3 3 2 5v3h2v3h2l5 6v2l4 1 4 6 8 7v2l5 2 2 4 5 2 3 1 1 2 9 4 6 2 7 5 5 6 4 2 1 2 5 2 5 5 12 7 3 3 7 5 10 3 5 3 8 3 9 4 15 5 18 4 6 2h7l1-6h6v2l-4 2v5l-2 1h-9l-24-7-13-4-20-8-16-8-17-11-14-10-7-6v-2l-4-2-5-3-16-8-16-12-16-16-12-16-7-11-9-17-7-15-8-24-5-19v-8l15-5 11-4h2l-5-19z",
    fill: "#DF927D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,665)",
    d: "m0 0 1 4-1 3 5 2 2 5-1 6-6 16-6 15-4 7-12 23-7 9-9 13-13 13-11 9-9 6-4 4-32 16-7 2-10 4-22 6-17 3-25 4-22 2h-40l-5-2-1-5v-3l-2-1h4l1 7 4 2 12-1h32l6-2 22-2 28-5 6-2 11-2 11-4 10-4 16-7 9-4 5-3 4-4 6-3 8-5 11-9 7-8 9-10 7-11 2-3h2l2-6 6-10 4-10 2-1 5-14 2-2 3-9 3-10 3-6-4-1-2-4-3-1 2-4z",
    fill: "#DF7F74"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(717,276)",
    d: "m0 0 2 4 2 14 5 10 8 5 18 3-2 2-16 2-7 4-6 10-3 17h-1l-3-17-4-8-5-4-9-3-12-2v-1l16-3 6-3 5-6 3-8z",
    fill: "#73A7E3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,837)",
    d: "m0 0h16l3 2v7l-3 14v12l3 5-1 2-4-5v-11l-2 1h-10v10l-3 5-2-1 3-5v-12l-2-9v-14z",
    fill: "#7EA3DD"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(304,418)",
    d: "m0 0 5 1 8 16 7 9 6 9 2 6 5 5-2 1-6-3-1-3-3-1-1-4h-2l-3-4v-2l-3-1-2-4-7-6v9l4 22 1 1v7l-3-3-1-11-4-16v-9h-2l-1-4 1-2-2-4v-3h2l1-5z",
    fill: "#AC352C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(792,574)",
    d: "m0 0h3l-3 9-2 4-2 10h-3l-2 11-3 1-1 8-3 6-3 9-5 6-1 7-5 3-3 4-2 8-4 2-2 3-2 7h6l2 5-1 7-3 5-2 6-2-1 1-7 2-5-1-7-5-3 1-8 4-4 2-4h2l1-6 5-7 6-11 5-11 6-14 3-9 5-12 3-8 1-3z",
    fill: "#9BB6E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(525,858)",
    d: "m0 0 5 5 3 1h11l7-4 1 4v9l-3 6-8 3h-7l-6-3-4-7v-12z",
    fill: "#D14740"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(484,857)",
    d: "m0 0 4 5 4 2h11l4-3h3v12l-4 6-5 3h-9l-6-3-4-7v-8z",
    fill: "#CF453F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(637,179)",
    d: "m0 0h2l3 13 5 5 4 2 9 1-1 2-9 2-6 3-4 9-2 5-2-1-2-8-3-5-4-3-11-2v-2l10-2 5-3 4-8z",
    fill: "#77A9E4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(246,593)",
    d: "m0 0 2 2 4 17 1 4-2 2h-3v2l-7 3-10 2-4 8 2 9 3 11 1 7 6 15 2 6h2l4 11v2h2l1 7h2l7 11 3 3 2 7-5-3-7-11-9-17-7-15-8-24-5-19v-8l15-5 11-4h2l-5-19z",
    fill: "#DF8A79"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,532)",
    d: "m0 0h1v49l-2 65v20l-2 31-1 9-1 37h-1v-47l1-24v-27l2-14 1-42 1-17z",
    fill: "#DD4A41"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,419)",
    d: "m0 0 5 2v2l2 1-7 7-2 5-1 4-4 1-2 5-7 6-9 11-7 6h-3v-3l3-3 4-7 5-5 7-9 6-10h2l2-4 4-4z",
    fill: "#AC352C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(310,413)",
    d: "m0 0 7 1 10 4 23 13 17 8 10 4 15 4v2h-8l-9-2-15-6-9-4v-2h-3v-2l-5-1-8-4-10-6-6-4-4 1-5 4-1-3-5-1-3 4h-5l5-5z",
    fill: "#BA4E46"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(707,416)",
    d: "m0 0 3 1-5 1-1 2-5 1-1 2-16 5-1 1-17 2-2 1-11 1h-27l-17-3-1-2-2-1 1-3v2l9 1 13 2h21l27-4 19-5z",
    fill: "#C36256"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(294,408)",
    d: "m0 0h6l-2 5-6 5v5l4 1-1 1 1 12 2 11v7l-2-4-3-7v-9l-1-3-6-1-2-5-3 1-1 5-3 2-7 15-3-2 9-16 4-7h2l2-6 5-7z",
    fill: "#B7423C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(764,416)",
    d: "m0 0 5 1 4 4v2l4 1 3 5 2 1v2h2l8 14 5 14 4 22v46l-3 15h-1l1-13 1-7v-40l-3-17-2-7h-2l-5-14-2-5-3-1-6-8v-2h-2l-4-6-7-2z",
    fill: "#C0584E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(468,321)",
    d: "m0 0h4l1 2 1 9 4 6 13 5-1 5h-2v2h-8v-2h-2l1 9 2 11v16h-1l-2-22-7-22-2-9z",
    fill: "#B5413B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(373,806)",
    d: "m0 0 6 1 5 3 8 3 9 4 15 5 18 4 6 2h7l1-6h6v2l-4 2v5l-2 1h-9l-24-7-13-4-20-8-9-5z",
    fill: "#DF8275"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,397)",
    d: "m0 0h1v50l-2 53h-1l-1-38 1-1v-19l-3 37h-1v-13l2-26v-8l2-13z",
    fill: "#C9423C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,249)",
    d: "m0 0h1v16l-9 2-8-3v-2l-5-1-3-3v-2h-2l-1-4 4 2 7 2 8-2 6-3h2z",
    fill: "#DB7A6F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(719,479)",
    d: "m0 0 2 1v2l3-1-1 5-9 18h-2l-1 4-6 12-7 6-1-2 5-8 2-5h2l3-9 4-9 4-13z",
    fill: "#AC352C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(551,358)",
    d: "m0 0h2l-1 7v21l6 8 2 5 4 2 1 3 4 2 10 8 14 7 11 3v3h4v2l-7-1-10-4v-2l-5-1-4-2v-2l-6-1-5-4v-2l-6-2-4-5-7-8-4-7v-25z",
    fill: "#B03E37"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(317,300)",
    d: "m0 0 2 1 3 8 1 3 7 1v2l-8 2-3 10-2 1-3-9-3-3-6-2 3-2 5-3 2-2z",
    fill: "#7AAAE5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,632)",
    d: "m0 0h1l-1 65-1 9-1 37h-1v-47l1-24v-27z",
    fill: "#C7433D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(261,720)",
    d: "m0 0 5 3v3h2l5 6v2l4 1 4 6 8 7v2l5 2 2 4 5 2 3 1 1 2 9 4 1 3-9-3-11-8-10-8-14-14-10-13z",
    fill: "#DF937E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,323)",
    d: "m0 0h1v10l-2 8-5 15h-1v-7l-9 1-1-1v-5l5-2h3l1-3 2 1 1-4 2 1 1-6h2z",
    fill: "#B2413B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(758,650)",
    d: "m0 0 1 2-2 8-4 2-2 3-2 7h6l2 5-1 7-3 5-2 6-2-1 1-7 2-5-1-7-5-3 1-8 4-4 2-4h2l2-5z",
    fill: "#A3BBE8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(246,593)",
    d: "m0 0 2 2 4 17 1 4-2 2h-3v2l-7 3-10 2-4 8 2 9-1 4-3-9-2-4v-8l15-5 11-4h2l-5-19z",
    fill: "#DF917D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(302,423)",
    d: "m0 0 3 1 3 10h2l2 6-5-3v9l4 22 1 1v7l-3-3-1-11-4-16v-9h-2l-1-4 1-2-2-4v-3z",
    fill: "#B3433D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(336,424)",
    d: "m0 0 5 2 21 11 12 5 18 5v2h-8l-9-2-15-6-1-4-6-2-15-8z",
    fill: "#CB7161"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(810,252)",
    d: "m0 0 1 4h2l9 11 3 9 7 9 3 7 2 4v3h-2l-10-18-3-5-10-16-3-5z",
    fill: "#A3BFF0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(312,440)",
    d: "m0 0 4 2 5 5-1-7 4 4 6 9 2 6 5 5-2 1-6-3-1-3-3-1-1-4h-2l-3-4v-2l-3-1-2-4-2-1z",
    fill: "#B3433D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(707,416)",
    d: "m0 0 3 1-5 1-1 2-5 1-1 2-16 5-1 1-16 1-1-3 24-5 11-4z",
    fill: "#BD564C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(870,416)",
    d: "m0 0 2 3v33l-1 11-1 1-2 9-2 2 1-13 2-22z",
    fill: "#A4BEEE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,236)",
    d: "m0 0 12 1-4 6h-2v2l-2 1h-6v-2l-5-1-3-4 4-2z",
    fill: "#CC6D60"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(788,441)",
    d: "m0 0 3 3 6 16 4 22v46l-3 15h-1l1-13 1-7v-40l-3-17-7-21z",
    fill: "#DF937E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(717,428)",
    d: "m0 0 1 2-1 4-3 1-6 11-3 3-1 3-4 1-1 5-3 1 1 2 4-2-4 5-6 5h-3v-3l3-3 4-7 5-5 7-9 6-10h2z",
    fill: "#B1403A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,279)",
    d: "m0 0 4 1 2 28 12 4v2l-14-1-4 3-1-4 3-3v-14l-1-10-1-4-3-1z",
    fill: "#D1443E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,826)",
    d: "m0 0m-6 1h6v2l-10 2-25 4-12 1v-3l1-1 22-2z",
    fill: "#DF8476"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480,861)",
    d: "m0 0h2l1 11 4 7 5 2h9l8-3-2 4-5 3h-10l-6-2-3-3-3-6z",
    fill: "#9FB8E7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(851,330)",
    d: "m0 0 4 3 2 9 7 20v9h-2l-6-21-5-15z",
    fill: "#A4BEEE"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(635,813)",
    d: "m0 0m-1 1m-3 1h3v2l-6 3-20 6-15 3 1-3 9-3 11-2 11-4z",
    fill: "#DF8175"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(247,508)",
    d: "m0 0h1v11l-3 6-1 43h-1l-1-6v-26l2-21z",
    fill: "#B3433D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,805)",
    d: "m0 0 8 1 10 2 9 1 21 1v1l-19 2h-9l-12-4-8-2z",
    fill: "#A5BEED"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(735,409)",
    d: "m0 0h7l4 4-3 1 1 4-3 2-4-1-6-6v-3z",
    fill: "#B7423C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(554,873)",
    d: "m0 0 1 2-4 5-3 5h-15l-8-5-1-4 10 5h7l9-3 2-4z",
    fill: "#A0B8E7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(792,574)",
    d: "m0 0h3l-3 9-2 4-2 10-6 2 1-6 5-11 2-7z",
    fill: "#9BB6E7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(618,235)",
    d: "m0 0 2 2 2 4 5 2v2l-6 3-2 4-5-5-3-2v-2l5-3z",
    fill: "#87B0E8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(224,634)",
    d: "m0 0 2 3 2 8 3 3 2 12 6 15 1 5h-2l-7-18-7-24z",
    fill: "#DF967F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(123,503)",
    d: "m0 0 2 1 6 32v8h-2l-3-16-2-9z",
    fill: "#A5BEED"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,665)",
    d: "m0 0 1 4-1 3 5 2 2 5-1 6-3 9-2-4 1-6 3-6-4-1-2-4-3-1 2-4z",
    fill: "#DF8D7B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(189,344)",
    d: "m0 0h2v2l-11 7-4 1v2l-8 6-4 1 4-6 5-3h2v-2l7-6z",
    fill: "#A5BEED"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(554,282)",
    d: "m0 0 2 1v7l-1 3-2 19h-7l-8 1 1-2 5-2 7-1z",
    fill: "#C2433D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,389)",
    d: "m0 0 3 1-8 16-8 13-3-2 6-9 8-14z",
    fill: "#DE8F7B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(450,820)",
    d: "m0 0 25 3 16 1 1 2h-18l-16-2-8-2z",
    fill: "#B6453F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(460,418)",
    d: "m0 0 2 1-1 3h-2l-2 5-2 4h-3v2l-10 3 4-5 3-1 9-11z",
    fill: "#CB695C"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(171,657)",
    d: "m0 0 5 3 7 13 3 5-1 4v-2l-4-2-3-5-3-10-4-2z",
    fill: "#A4BEEE"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,447)",
    d: "m0 0h1v31l-1 22h-1l-1-38 1-1z",
    fill: "#C6433D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(525,858)",
    d: "m0 0 2 2v12l5 5v2l10 1-1 2h-7l-6-3-4-7v-12z",
    fill: "#BE524B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(227,624)",
    d: "m0 0h4l-1 4-3 3 2 11-1 4-3-9-2-4v-8z",
    fill: "#DF8878"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(551,358)",
    d: "m0 0h2l-1 7v21l6 8 2 5 2 1-5-1-7-11v-25z",
    fill: "#AF3B34"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(403,298)",
    d: "m0 0h2l2 4 4 3-5 3-3 3-5-5-1-2 3-1z",
    fill: "#81AAE2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(393,121)",
    d: "m0 0h3l-1 4-3 1v2l-5 5-10 12-1-3 5-6h2l2-6 3-3h2l2-5z",
    fill: "#A4BEEE"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(283,422)",
    d: "m0 0 2 3-4 2-1 5-3 2-7 15-3-2 9-16 4-7z",
    fill: "#B3433D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(478,285)",
    d: "m0 0h1l1 9v13l10 3 10 4 4 3-6-1-12-5-7-3-1-10z",
    fill: "#DF7F74"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,864)",
    d: "m0 0h1v7l5 2 2 3v3l11 1v2h-9l-6-3-4-7z",
    fill: "#C1564E"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(824,276)",
    d: "m0 0 5 5 4 7 4 8v3h-2l-10-18z",
    fill: "#A4BEEE"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(462,86)",
    d: "m0 0h5l-2 2-20 5-6 1v-3l16-4z",
    fill: "#A6BEEC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(554,293)",
    d: "m0 0h1l1 17 4 6v2h2l1 5h-2l-1 8-3 1 1-4v-10l-5-9z",
    fill: "#DC7B71"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(551,279)",
    d: "m0 0 9 2-3 1v6h-1l-1-5-2 13-1 12-1 1h-7v-1l6-1 2-22 1-5z",
    fill: "#DA786D"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(522,237)",
    d: "m0 0 2 1-4 5h-2v2l-2 1h-6v-2l-5-1-3-4 4-1 1 3h13v-3z",
    fill: "#B8423C"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(367,159)",
    d: "m0 0 1 3-7 14-1 3h-2v-7l6-12z",
    fill: "#A3BFEF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(243,568)",
    d: "m0 0h2l3 22-1 4-2-1-2-11z",
    fill: "#C15D52"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(313,266)",
    d: "m0 0h2l-1 5-14 14-3 1 1-4 5-3 2-4 4-4h2z",
    fill: "#A3BFEF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(717,428)",
    d: "m0 0 1 2-1 4-3 1-6 11-3 3-1 3-5 1 6-8 8-13h2z",
    fill: "#B3433D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,283)",
    d: "m0 0 2 2 1 12v12l-3 3-2 9h-3l1-4 3-8 2-1z",
    fill: "#DF7F74"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(819,556)",
    d: "m0 0 2 1-1 2-4 2-1 3-10 5-2 2h-3l1-3 6-4 8-6z",
    fill: "#A3BFF0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(408,481)",
    d: "m0 0 2 1-8 7h-2v3l-4 2-2 4-7 1 5-6 7-5h2v-2l6-4z",
    fill: "#B3433D"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(250,701)",
    d: "m0 0h2l7 11 3 3 2 7-5-3-6-10z",
    fill: "#DF8878"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(298,455)",
    d: "m0 0 2 3 5 12 4 14 1 4-4-4-3-12-3-6-2-5z",
    fill: "#B3433D"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(699,147)",
    d: "m0 0 6 2 10 7v2l-6-1-10-7z",
    fill: "#A4BEEE"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,309)",
    d: "m0 0 4 1-15 6-6 3-5 1h-10v-1l12-2 16-6z",
    fill: "#DF7F74"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,421)",
    d: "m0 0 9 2 5 1v3h4v2l-7-1-10-4z",
    fill: "#B3413A"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(714,415)",
    d: "m0 0 7 1 8 4 2 3h-3l-3-3-2-1-1 5-4 4 2-10-7-1z",
    fill: "#B5433D"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,485)",
    d: "m0 0 3 3 6 9 5 10 1 5-5-5-1-4-3-5-6-11z",
    fill: "#ED5045"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(771,208)",
    d: "m0 0h4l6 8 3 2v4l-4-2-9-10z",
    fill: "#A2BFF0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(700,309)",
    d: "m0 0 2 1-5 2v1l7 1 1 3-9-2-12-2v-1z",
    fill: "#94B7EE"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(249,494)",
    d: "m0 0h1v11l-4 6-2 4 1-9 2-10h2z",
    fill: "#C66759"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(788,441)",
    d: "m0 0 3 3 6 16 2 12-2-2-3-11-3-8z",
    fill: "#DF9880"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,441)",
    d: "m0 0h1v20l-2 6h-1l1-25z",
    fill: "#AC352C"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(161,364)",
    d: "m0 0h2l-1 4-5 4-7 9-3-1 3-5 10-10z",
    fill: "#A4BEED"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(758,650)",
    d: "m0 0 1 2-2 8-8 5-2 1 2-4 4-6h2l2-5z",
    fill: "#A1BAE8"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,213)",
    d: "m0 0 6 1v5l-1 1h-5v-5l-7 3 1-3z",
    fill: "#30201C"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(524,212)",
    d: "m0 0 8 1 3 1v2l-6-2v5h-5v-4l-3-1z",
    fill: "#2A1D1A"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(792,574)",
    d: "m0 0h3l-3 9-2 4h-2l1-9 1-3z",
    fill: "#A9BFEA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(865,378)",
    d: "m0 0 3 3 1 10v9l-2-2-2-12z",
    fill: "#A2BFF0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(417,484)",
    d: "m0 0v3l-8 10-7 9h-2l2-4 4-6h2v-2l2-1 1-3h2l2-4z",
    fill: "#C7433D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,411)",
    d: "m0 0 3 3 7 18 1 5-3-2-3-9-4-10z",
    fill: "#ED5045"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(778,602)",
    d: "m0 0h2v5h-2l-3 9-2 5-2-1 2-7 2-4 2-6z",
    fill: "#C0564E"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(373,533)",
    d: "m0 0 3 1-11 10-2 4-5 1 6-7 7-8z",
    fill: "#D2443E"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(726,167)",
    d: "m0 0 5 2 5 3 1 3 3 3-5-1-5-4v-2l-4-2z",
    fill: "#A4BEEE"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(132,551)",
    d: "m0 0 3 3 3 11v9l-2-2-3-15z",
    fill: "#A5BEED"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(294,436)",
    d: "m0 0 2 1 2 11v7l-2-4-3-7z",
    fill: "#B3433D"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(707,416)",
    d: "m0 0 3 1-5 1-1 2-12 3-9 1v-1l13-4z",
    fill: "#DF927D"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(717,276)",
    d: "m0 0 2 4 1 13-3-2-2 1z",
    fill: "#8CAFE7"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(261,720)",
    d: "m0 0 5 3v3h2l5 6 3 5-1 2-8-9-6-8z",
    fill: "#DF9C82"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,80)",
    d: "m0 0 1 2h11l2 2h-18l-3-2z",
    fill: "#A8BEEA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(398,506)",
    d: "m0 0h2l-2 4-12 14-2 1 2-4 6-9 5-5z",
    fill: "#CF433D"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(324,451)",
    d: "m0 0 6 3 2 5 5 5-2 1-5-4-4-4z",
    fill: "#AC352C"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(785,224)",
    d: "m0 0 4 2 8 8-1 3-7-6-4-5z",
    fill: "#A3BFEF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(201,705)",
    d: "m0 0h2l8 12-1 3-8-10z",
    fill: "#A3BFEF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(552,306)",
    d: "m0 0h1v6h-7l-8 1 1-2 5-2 7-1z",
    fill: "#D4453F"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(256,475)",
    d: "m0 0h1v5l-2 3-2 7-3 3 2-10 3-7z",
    fill: "#B3433D"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(416,103)",
    d: "m0 0m-1 1m-1 1m-2 1 2 1-4 5-10 8-1-2 5-5z",
    fill: "#A5BEED"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,83)",
    d: "m0 0 16 1v2h-17l-3-2z",
    fill: "#A4BEEE"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(273,734)",
    d: "m0 0 4 1 4 6 6 7-4-1-7-7z",
    fill: "#DF8979"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,470)",
    d: "m0 0h1l-1 30h-1l-1-28z",
    fill: "#D0433D"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(420,446)",
    d: "m0 0 4 1-3 2-11 2-6-1 3-2z",
    fill: "#C36457"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,826)",
    d: "m0 0h4l1 7 4 2h8l-2 2h-7l-5-2-1-5v-3z",
    fill: "#DF7F74"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(738,311)",
    d: "m0 0 14 1-2 2-14 1z",
    fill: "#90B1E6"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,180)",
    d: "m0 0 10 5 1 6-9-6z",
    fill: "#A5BEED"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(747,690)",
    d: "m0 0h1v6l-3 8-2-1 1-7z",
    fill: "#DF8175"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(342,430)",
    d: "m0 0 5 1 12 6v2l-8-2v-2h-3v-2l-5-1z",
    fill: "#B5433D"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400,239)",
    d: "m0 0h14l1 2-15 1z",
    fill: "#8CACE2"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,279)",
    d: "m0 0 4 1v12l-2 1-2-12-3-1z",
    fill: "#C1423C"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,557)",
    d: "m0 0 6 2 2 1v8l-4-5z",
    fill: "#ED5045"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(460,418)",
    d: "m0 0 2 1-1 3h-2l-2 5-4 2 2-6z",
    fill: "#C15249"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(351,290)",
    d: "m0 0 1 3h2v12l-2 1-1-7z",
    fill: "#83A7DF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(164,641)",
    d: "m0 0 3 1 1 6h2v7l-2-2-4-8z",
    fill: "#A5BEED"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(350,554)",
    d: "m0 0 2 1-1 2h-2l-1 3h-2l-1 3-5 3-4 1 5-5 8-7z",
    fill: "#DD4941"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(314,766)",
    d: "m0 0h5l3 3 5 3-1 2-2-2-9-3z",
    fill: "#DF8878"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(754,653)",
    d: "m0 0 1 3-2 1-3 5-3 2v-4l5-6z",
    fill: "#C45F55"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(755,413)",
    d: "m0 0 5 1 4 2-1 4-8-4z",
    fill: "#B3433D"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,400)",
    d: "m0 0 4 1 1 3 3 1 1 4-5-2-4-6z",
    fill: "#B1403A"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(141,389)",
    d: "m0 0 1 3-6 12h-2l1-4 5-10z",
    fill: "#A4BEEE"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(173,354)",
    d: "m0 0 3 2-8 6-4 1 4-6z",
    fill: "#A3BFEF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,864)",
    d: "m0 0h1v9l-3 5h-3l2-4z",
    fill: "#BB4E47"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(256,468)",
    d: "m0 0h3l-1 6-3 3-2 3 1-7z",
    fill: "#CA6C5E"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(127,423)",
    d: "m0 0h1l-1 9-2 6h-1v-9z",
    fill: "#A3BFEF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(403,298)",
    d: "m0 0h2l2 4 4 3-6 3 1-4-4-2v2l-2-1z",
    fill: "#9ABAEE"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(507,239)",
    d: "m0 0h10l1 3h-11z",
    fill: "#EABFAE"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(525,858)",
    d: "m0 0 2 2-1 12h-2v-12z",
    fill: "#BB4F48"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,389)",
    d: "m0 0 3 1-7 14-1-2 2-7 3-5z",
    fill: "#DF8D7B"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(641,208)",
    d: "m0 0 1 3-4 10-2-1-1-7h2v2h2l1-5z",
    fill: "#95B7EE"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(245,693)",
    d: "m0 0 4 1 3 10 1 4-3-3-5-10z",
    fill: "#DF9B82"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,198)",
    d: "m0 0 3 1-4 1v2l2 1-11-1v-2z",
    fill: "#96B5E9"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(240,754)",
    d: "m0 0 4 2 6 5v3h-2l-4-5-4-3z",
    fill: "#A2BFF0"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(751,662)",
    d: "m0 0v3l-1 8-4-1 1-6z",
    fill: "#A8BEEA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(129,531)",
    d: "m0 0h1l1 5v8h-2l-1-4v-7z",
    fill: "#A2BFF0"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(311,315)",
    d: "m0 0 4 2 2 4 3-1-1 7-2 1-3-9z",
    fill: "#93B7EF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(317,300)",
    d: "m0 0 2 1 3 8 1 3h-2l-4-5h-1z",
    fill: "#96B8EF"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(361,799)",
    d: "m0 0 7 4 5 2v2l-5-1-7-4z",
    fill: "#DF947E"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(303,762)",
    d: "m0 0 7 1 4 2 1 3-9-3z",
    fill: "#DF9981"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(121,485)",
    d: "m0 0h2l1 3v9l-2-1-1-4z",
    fill: "#A3BFEF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,315)",
    d: "m0 0 10 3 2 1v2l-6-1-6-3z",
    fill: "#D2443E"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(269,304)",
    d: "m0 0 2 1-5 5h-2v2h-3l2-4z",
    fill: "#A4BEEE"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(657,122)",
    d: "m0 0 8 2 1 4-5-1-4-4z",
    fill: "#A4BEEE"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(511,864)",
    d: "m0 0 2 1v10l-4 3z",
    fill: "#A8BEEA"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(171,657)",
    d: "m0 0 5 3 2 6-3-1v-2l-4-2z",
    fill: "#A2BFF0"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(429,96)",
    d: "m0 0h6l-4 3-3 2h-4v-2z",
    fill: "#A4BEED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/svg-3.7ea2a39b8f131cc904cdc6d8094bc69c.svg";
export { ForwardRef as ReactComponent };